import React, {useState} from 'react';
import TitleWithIcon from './TitleWithIcon'
import VisDiv from './frontend_components/VisDiv';
import { AiFillPlusCircle } from 'react-icons/ai';
import {useStateContext} from '../context/StateContext';
import ModalContent from './ModalContent';
import NewDeviceField from './NewDeviceField';
import TextField from './TextField';
import { v4 as uuidv4, v4 } from 'uuid';
import RegisterIcon from './RegisterIcon';
import useNetworkStatus from '../hooks/useNetworkStatus';
import useNetwork from '../hooks/useNetwork';
import { successAlert,errorAlert, keyId  } from '../lib/utils';
import { useQueryClient } from '@tanstack/react-query';
import { clientUser } from '../lib/userPermissions';



const SliderRegistriTemplates = ({registers, templates, setLoading, registerTemplateFilter, setRegisterTemplateFilter, closeAllInfo=()=>{}}) => {

    const {
        site,
        register,
        setRegister,
        setCurrentTemplate,
        sUser,
        LDB,
    } = useStateContext();


    const networkStatus = useNetworkStatus()

    const testing = false


    const testFunction = () => {
        console.log("testFunction")
        //console.log("tamplates", templates)
    }
    

    const filterFn = (item) => {
       
        console.log("click filter", item);
        setRegisterTemplateFilter(item)

    }

        

    const setCurrentRegister = (registerIcon, template) => {
        setLoading(true)
        //console.log("set register:",registerIcon)
        //console.log("current register", register)
        setCurrentTemplate(template)
        setRegister(registerIcon)
        closeAllInfo()
        //window.location.reload(false);
        setLoading(false)
    }


    
    const isActive = (registerIcon) => {
        if(registerIcon?._id == register?._id) return true
        return false
    }

    const registerTemplateData = (registerIcon) => !Array.isArray(templates) ? undefined : templates?.find?.((x)=>x._id==registerIcon?.template?._ref)

    const selectRegister = (register, currentRegister) => {
        if(register?._id == currentRegister?._id){
            setRegisterTemplateFilter(undefined)
            console.log("SELECT REGISTER", undefined)
        }
        else {
            setRegisterTemplateFilter(register)
            console.log("SELECT REGISTER", register)
        }

    }
    function compare( a, b ) {
        if ( a?.order < b?.order ){
          return -1;
        }
        if ( a?.order > b?.order ){
          return 1;
        }
        return 0;
      }

    const orderedRegisters = registers?.map?.((item)=>{
        const template = !Array.isArray(templates) ? undefined : templates?.find?.(x=>x?._id==item?.template?._ref) 
        //console.log(template?.order)
        return ({...item, order:template?.order })
        }) 

  return (
    <>
    <div className='horizontal-swipe-wrapper'>
        
            {templates && templates?.filter((x=>x?.status !== "ARCHIVIATO")).sort(compare).map?.((item)=>(
                <VisDiv rules={[networkStatus, clientUser(sUser) ]} key={item._id} className='horizontal-swipe-box' style={{backgroundColor:"",}}> 
                    <RegisterIcon noPlus currentTemplate={registerTemplateFilter} iconSize={65} template={item} templates={templates} onClick={()=>selectRegister(item, registerTemplateFilter)}/> 
                </VisDiv>
          ))}
     
    </div>
    <VisDiv rules={[testing]}><button onClick={testFunction}>test</button></VisDiv>    
    </>
  )
}

export default SliderRegistriTemplates
